export enum LoginOrigin {
  LTI = 'LTI',
  LTI13 = 'LTI13',
  RS = 'RS',
  WEB = 'WEB',
  SSO = 'SSO',
}

export type Role = 'ADMIN' | 'ST' | 'AM' | 'LMSC' | 'MKT' | 'RPT';

export type User = {
  Id: number;
  FirstName: string;
  LastName: string;
  FullName: string;
  Country: string;
  CompanyId: number;
  CompanyUuid: string;
  CompanyName: string;
  CompanyTypeId: number;
  ExternalPersonReference: string;
  ExternalCompanyReference: string;
  Role: Role[];
  LoginOrigin: LoginOrigin;
};

export type JWT = {
  AAC: number[];
  CompanyName: string;
  CompanyUuid: string;
  Country: string;
  IssueDate: string;
  LastCall: string;
  LoginOrigin: LoginOrigin;
  PersonId: number;
  PersonUuid: string;
  SelectedLanguage: string | null;
  TokenDateTime: string;
  TokenId: number;
  UUID: string;
  UserAgent: string;
};
